import VARIABLE_LABEL_NAME_PATTERN from '@/support/constants/global.js';
import { formatBytes } from './global.js';
import { alphabetsOnly, urlPattren, resetPasswordPattern } from './patterns.js';
const alphabets = (value) => {
  let pattern = new RegExp(alphabetsOnly, 'g');
  return pattern.test(value) || 'Alphabets Only';
};

const required = (value) => !!value || 'This feild is required';
const autoCompleteValidation = (value) => {
  return value.length > 0 || 'Required.';
};

const minLength = (value, length) => {
  if (value) {
    return (
      value.length > length || `This feild must have length of ${length} chars`
    );
  } else {
    return 'This feild is required';
  }
};
const fileSize = (value, size) => {
  return (
    !value ||
    value.size < size ||
    `File size should be less than ${formatBytes(size)} !`
  );
};

const commaSeparatedEmails = (emailList) => {
  const emails =
    emailList.length > 0 ? emailList.replace(/\s/g, '').split(',') : [];
  var valid = true;
  // eslint-disable-next-line no-useless-escape
  var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  for (var i = 0; i < emails.length; i++) {
    if (emails[i] === '' || !regex.test(emails[i])) {
      valid = false;
    }
  }
  return valid || 'One or more emails are not valid';
};

const url = (str) => {
  var pattern = new RegExp(urlPattren, 'i'); // fragment locator
  return !!pattern.test(str) || 'URL is not valid';
};

const alphanumeric = (value) => {
  const pattern = /^[ A-Za-z0-9_./# &+-]*$/;
  return (
    pattern.test(value) || 'Special Characters & Initial Numbers Not allowed'
  );
};
const sharedAlphanumeric = (value) => {
  const pattern = /^[ A-Za-z0-9_./# &+-]*$/;
  return (
    pattern.test(value) ||
    'Special Character and Initial numbers are not allowed and the string length should be from 3 to 20.'
  );
};
const emailRules = [
  (value) => !!value || 'Email required',
  (value) => /@.+\..+/.test(value) || 'Invalid email',
];
const passwordRules = [
  (value) => !!value || 'One A-Z and a-z and 1-9 and min 8 character',
  (value) =>
    (value && value.length >= 8) ||
    'One A-Z and a-z and 1-9 and min 8 character',
  (value) =>
    /[a-z]/.test(value) || 'One A-Z and a-z and 1-9 and min 8 character',
  (value) =>
    /[A-Z]/.test(value) || 'One A-Z and a-z and 1-9 and min 8 character',
  (value) =>
    /[0-9]/.test(value) || 'One A-Z and a-z and 1-9 and min 8 character',
];

// Variable label name
const variableLabelRule = (value) => {
  return (
    VARIABLE_LABEL_NAME_PATTERN.test(value) ||
    'Special Characters and numbers not allowed and string length should be from 3 to 20.'
  );
};
const resetPasswordRules = [
  (value) => !!value || 'At least one special character, one A-Z, one a-z, one 0-9 and min 8 characters and max 15 characters required.',
  (value) =>
  resetPasswordPattern.test(value) || 'At least one special character, one A-Z, one a-z, one 0-9 and min 8 characters and max 15 charaters required.',
];
const cpasswordRules = [
  (value) => !!value || '',
  (value) => value === this.input.password || 'Password must match',
];
const firstNameRules = [
  (value) => !!value || 'Special characters and Numbers are not allowed',
  (value) =>
    /^[A-Za-z_ ]{3,10}$/.test(value) ||
    'Special Character or Numbers are not allowed and the string length should be from 3 to 10.',
];
const editEmailRules = [
  (value) => !!value || '',
  (value) => /@.+\..+/.test(value) || 'Invalid email',
];
const inviteEmailRule = [
  (val) => !!val || '',
  (val) => /@.+\..+/.test(val) || '',
];
const negativenumeric = (value) => {
  const pattern = /^[-0-9]*0$/;
  return pattern.test(value) || "Only multiple's of 10 is allowed.";
};
const specialCharectersCheckForLable = (value) => {
  const pattern = /^[a-zA-Z][a-zA-Z\s ]{1,19}$/;
  return pattern.test(value) || 'Special Characters and numbers not allowed.';
};
const uploadAccept = (value) =>
  !value || value.size < 10000 || 'Image size should be less than 10 KB!';

export {
  required,
  minLength,
  commaSeparatedEmails,
  url,
  alphanumeric,
  emailRules,
  passwordRules,
  variableLabelRule,
  resetPasswordRules,
  cpasswordRules,
  firstNameRules,
  editEmailRules,
  autoCompleteValidation,
  negativenumeric,
  specialCharectersCheckForLable,
  inviteEmailRule,
  sharedAlphanumeric,
  uploadAccept,
  fileSize,
  alphabets,
};
